import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { catchError, filter, map, shareReplay, switchMap } from 'rxjs/operators';

import { Manager } from '@shared/models/manager';

import { ManagerAutoOptionAdapter } from './../models/manager';
import { ApiService } from './api.service';
import { Pagination } from '@shared/pagination';

@Injectable({ providedIn: 'root' })
export class CompanyManagerService extends ApiService<Manager> {
  filteredCompaniesManagers$: Observable<Pagination<Manager>>;
  filteredOptions$: Observable<Manager[]>; // TODO: create better type
  private filteredCompaniesSubject = new Subject<any>();

  constructor(http: HttpClient) {
    super(http);
    this.url = 'company/managers/';

    this.filteredCompaniesManagers$ = this.filteredCompaniesSubject.pipe(
      filter((filter) => filter.name !== null && filter.name.length > 2),
      switchMap((filter) => this.getFilterCompaniesManagers(filter.name, filter.companyId)),
      shareReplay(1),
    );

    this.filteredOptions$ = this.filteredCompaniesManagers$.pipe(
      map((companiesManagers: Pagination<Manager>) =>
        (companiesManagers.content || []).map((companyManager: Manager) =>
          ManagerAutoOptionAdapter.toOption(companyManager),
        ),
      ),
      shareReplay(1),
    );
  }

  filter(name: string, companyId: number): void {
    this.filteredCompaniesSubject.next({ name, companyId });
  }

  getCompanyManager(managerId: number): Observable<Manager | undefined> {
    if (!managerId) {
      return of(undefined);
    }
    const request = {
      url: `${managerId}`,
    };
    return this.get(request).pipe(catchError(this.handleError));
  }

  getFilterCompaniesManagers(
    filterText: string,
    companyId: number,
    offset = 0,
  ): Observable<Pagination<Manager>> {
    let params = new HttpParams().set('name', filterText).set('offset', offset.toString());
    params = params.append('name', filterText);
    return this.http
      .get(`${this.config.API_BASE_URL}/company/${companyId}/managers/autocomplete`, { params })
      .pipe(catchError(this.handleError));
  }
}
